import { render, staticRenderFns } from "./MessageListSortOrder.vue?vue&type=template&id=485d6eb2&scoped=true"
import script from "./MessageListSortOrder.vue?vue&type=script&lang=js"
export * from "./MessageListSortOrder.vue?vue&type=script&lang=js"
import style0 from "./MessageListSortOrder.vue?vue&type=style&index=0&id=485d6eb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485d6eb2",
  null
  
)

export default component.exports